import styled from 'styled-components'
import { colors } from '~/styles/colors'

export const Wrapper = styled.div<{ color: string }>(props => ({
  maxWidth: 450,
  margin: '0 auto',
  border: colors.border,
  borderRadius: 2,
  padding: '24px 30px 24px',
  background: '#fff',
  '--kindest-primary-default': props.color,
  '--kindest-primary-light': props.color,
  '--kindest-primary-dark': props.color,
}))